const contentType = {
  post: 1,
  homework: 2,
  attChangeRequest: 3,
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { attChangeRequest, ...uploadableContentType } = contentType;

export const Content = {
  Type: contentType,
  UploadableType: uploadableContentType,
  SubType: {
    boardPost: 1,
    notePost: 2,
    none: 99,
  },
  File: {
    Kind: {
      image: 1,
      video: 2,
      attachment: 3,
      audio: 4,
    },
    DeletedReason: {
      contentDeleted: 1,
      ttlExpired: 2,
      adminDeleted: 3,
    },
  },

  Point: {
    ChargePack: {
      points5000: { points: 5000, amount: 5500 },
      points10000: { points: 10000, amount: 11000 },
    },
    autoChargePhotoCountThreshold: 500,
    autoChargePack: 'points10000',
    maxDailyChargeCount: 4,
    AutoCharge: {
      none: 0,
      points5000: 1,
      points10000: 2,
    },
    ChargeMethod: {
      auto: 1,
      manual: 2,
      admin: 3, // event 등
    },
    ImagePoints: {
      teacherSide: 5,
      studentSide: 1,
    },
    FileMultiplier: {
      image: 1,
      video: 10,
      attachment: 10,
      // 음성은 사진의 3배. 보관 정책은 사진과 동일하게 학생 측 1개월, 교사 측 1년.
      // 기간 만료에 따른 삭제는 별도 정리 작업에서 적용한다.
      audio: 3,
    },
  } as const,

  Comment: {
    Type: {
      text: 1,
      image: 2,
      attachment: 3,
      audio: 4,
    },
  },
};
